export const educationApiBaseUrl = import.meta.env.VITE_MY_ENGINE_API!;
export const courseBffApiBaseUrl = import.meta.env.VITE_COURSE_BFF_API!;

export const educationApiUrl = `${educationApiBaseUrl}/api`;
export const courseBffApiUrl = `${courseBffApiBaseUrl}/api`;

export const getCourseEndpoint = (courseId: number) =>
  `${courseBffApiUrl}/courses/course/${courseId}`;
export const getCourseContentEndpoint = (courseId: number) =>
  `${courseBffApiUrl}/courses/course/${courseId}/content`;
export const getCourseUserProgressEndpoint = (courseId: number) =>
  `${courseBffApiUrl}/courses/course/${courseId}/user-progress`;
export const getCourseToggleFavoriteEndpoint = (courseId: number) =>
  `${courseBffApiUrl}/courses/course/${courseId}/favorite`;
export const getCoursemilestoneEndpoint = () => `${courseBffApiUrl}/courses/milestone`;
export const getCourseIdEndpoint = (courseCode: string) =>
  `${courseBffApiUrl}/courses/course-id/${courseCode}`;

export const getCourseMetadataEndpoint = (courseId: number) =>
  `${courseBffApiUrl}/courses/course/${courseId}/metadata`;
export const getCourseProgressEndpoint = (courseId: number) =>
  `${courseBffApiUrl}/courses/course/${courseId}/progress`;
export const getCourseMilestonesEndpoint = (courseId: number) =>
  `${courseBffApiUrl}/courses/course/${courseId}/milestones`;

export const getLessonEndpoint = (lessonId: number) =>
  `${courseBffApiUrl}/lessons/lesson/${lessonId}`;

export const getLessonMilestonesEndpoint = (lessonId: number) =>
  `${courseBffApiUrl}/lessons/lesson/${lessonId}/milestones`;

export const getActivityDetailsEndpoint = (slug: string) =>
  `${courseBffApiUrl}/activities/activity/${slug}`;
export const getGhccSsoEndpoint = () => `${courseBffApiUrl}/activities/ghcc-sso`;
export const getGhccStartActivityEndpoint = () => `${courseBffApiUrl}/activities/start`;
export const getUpdateProgressEndpoint = () => `${courseBffApiUrl}/activities/progress`;
export const getCoursePlayerEventEndpoint = () => `${courseBffApiUrl}/activities/event`;
export const getCoursePlayerRatingEndpoint = () => `${courseBffApiUrl}/activities/rating`;

export const getStartActivityEndpoint = () => `${courseBffApiUrl}/activities/v2/start`;
export const getProgressReportEndpoint = () => `${courseBffApiUrl}/activities/v2/progress`;

export const getWebsessionEndpoint = () => `${educationApiUrl}/websession2`;
export const getWebsessionWithIdEndpoint = () => `${educationApiUrl}/websession2/0`;
export const getCertificateDownloadEndpoint = () => `${educationApiUrl}/CertificateDownload`;
